import { customerMarketShopfrontApi } from '@envato/foundation-types'

import {
  ActionTypes as CategoryPageActionTypes,
  TypeKeys as CategoryPageTypeKeys
} from '../actions/categoryPage'

export interface ICategoryPageResult
  extends customerMarketShopfrontApi.categoryPage.IResult {
  blocks: customerMarketShopfrontApi.categoryPage.ICategoryPageBlock[]
  blocksB: customerMarketShopfrontApi.categoryPage.ICategoryPageBlock[]
  blocksC: customerMarketShopfrontApi.categoryPage.ICategoryPageBlock[]
}

export interface IState extends ICategoryPageResult {
  isLoading: boolean
  dataRequestFailed?: boolean
}

const initialState: IState = {
  metadata: {
    title: '',
    description: '',
    heading: '',
    sub_heading: ''
  },
  topArticle: '',
  category: '',
  blocks: [],
  blocksB: [],
  blocksC: [],
  isLoading: false
}

export const reducer = (
  state = initialState,
  action: CategoryPageActionTypes
): IState => {
  switch (action.type) {
    case CategoryPageTypeKeys.GET_CATEGORY_PAGE_API_REQUEST:
      return {
        ...state,
        metadata: initialState.metadata,
        category: initialState.category,
        isLoading: true
      }

    case CategoryPageTypeKeys.GET_CATEGORY_PAGE_API_SUCCESS:
      const {
        metadata,
        topArticle,
        category,
        blocks,
        blocksB,
        blocksC
      } = action.payload

      return {
        metadata,
        topArticle,
        category,
        blocks,
        blocksB,
        blocksC,
        isLoading: false
      }

    case CategoryPageTypeKeys.GET_CATEGORY_PAGE_API_FAIL:
      return {
        ...state,
        isLoading: false,
        dataRequestFailed: true
      }

    default:
      return state
  }
}
